import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { useState } from 'react';
import getFirstDayOfWeek from '#utils/getFirstDayOfWeek';
import { CalendarPeriodic } from '../../types';
import DaySelectModal from './DaySelectModal';
import * as S from './styles';
import { getDateString } from './utils';

dayjs.extend(weekOfYear);

interface Props {
  date?: Date | dayjs.Dayjs | string;
  calendarPeriodic: CalendarPeriodic;
  onChange: (date: dayjs.Dayjs) => void;
}

export default function DatePicker({
  date,
  calendarPeriodic,
  onChange
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>();

  const handleClickPrev = () => {
    let nextDate: dayjs.Dayjs;

    if (calendarPeriodic === 'WEEKLY') {
      const previousWeek = dayjs(date).subtract(1, 'week');
      nextDate = getFirstDayOfWeek(previousWeek);
    } else {
      nextDate = dayjs(date).subtract(1, 'day');
    }

    if (onChange) {
      onChange(dayjs(nextDate));
    }
  };

  const handleClickNext = () => {
    let nextDate: dayjs.Dayjs;

    if (calendarPeriodic === 'WEEKLY') {
      const nextWeek = dayjs(date).add(1, 'week');
      nextDate = getFirstDayOfWeek(nextWeek);
    } else {
      nextDate = dayjs(date).add(1, 'day');
    }

    if (onChange) {
      onChange(dayjs(nextDate));
    }
  };

  return (
    <>
      <S.Container>
        <S.SelectDateButton onClick={() => setIsOpen(true)}>
          {getDateString(dayjs(date), calendarPeriodic)}
        </S.SelectDateButton>
        <S.ButtonGroup>
          <S.ButtonPrev onClick={handleClickPrev} />
          <S.ButtonNext onClick={handleClickNext} />
        </S.ButtonGroup>
      </S.Container>
      {isOpen && (
        <DaySelectModal
          calendarPeriodic={calendarPeriodic}
          date={date}
          onClose={() => setIsOpen(false)}
          onSubmit={date => {
            if (onChange) {
              onChange(date);
            }
          }}
        />
      )}
    </>
  );
}
